import React from "react";
import { Decrypt } from "@/utils/encrypt";
import { Local } from "@/utils/local";
import { message } from "antd";
import axios from "axios";
import { removeAllCookie } from "@/utils/cookie";
let baseURL = "/s/api";
axios.defaults.timeout = 60000;
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";
axios.defaults.baseURL = baseURL;
axios.interceptors.request.use(config => {
  config.headers.Memory = 1; // 登录

  let accessToken = Local.get("token") ? Local.get("token") : "";
  let userId = Local.get("userInfo") ? JSON.parse(Decrypt(Local.get("userInfo"))).userId : "";
  let companyId = Local.get("userInfo") ? JSON.parse(Decrypt(Local.get("userInfo"))).companyId : "";
  config.headers.Authorization = accessToken;
  config.headers.companyId = companyId;
  config.headers.userId = userId != null ? userId : ""; // 新增参数

  config.headers.platform = "pc";
  return config;
}, error => {
  Promise.reject(error);
});
axios.interceptors.response.use(response => {
  // 错误信息拦截提示
  handleErrorRes(response, baseURL);
  return response;
}, error => {
  if (error.response) {
    const hash = `${window.location.pathname}${window.location.hash}`;
    const queryString = window.encodeURIComponent(hash);
    let {
      status,
      headers,
      data
    } = error.response || {};
    let {
      action
    } = headers || {};
    let interceptList = ["cc", "waf"];
    console.log("response -> error 2", error.response);

    switch (status) {
      case 401:
        window.location.href = `${window.location.origin}${process.env.REACT_APP_HTTP_PATH}/upgrade/token?callback=${queryString}`;
        localStorage.clear();
        break;

      case 403:
        // 错误信息拦截
        if (interceptList.includes(action)) {
          let newWin = window.open("", "_blank");
          newWin.document.write(data);
          newWin.document.close();
        } else {
          window.location.href = `${window.location.origin}${process.env.REACT_APP_HTTP_PATH}/upgrade/token?callback=${queryString}`;
          localStorage.clear();
        }

        break;

      case 409:
        message.destroy();
        message.warning("您的账号已在别处登录，被迫下线");
        axios({
          method: "post",
          url: `${window.location.origin}/loginoutNew`
        }).then(res => {
          Local.remove("token");
          Local.remove("userInfo");
          Local.remove("main_color");
          Local.remove("useLoginPage");
          removeAllCookie();
          let url = "";
          if (res.loginSchoolPath) url = res.loginSchoolPath;
          window.location.href = `${window.location.origin}${url}`;
        });
        break;
    }
  }

  return Promise.reject(error);
});
/**
 * response 服务返回信息
 * _baseURL 基础过滤路径
 * */

function handleErrorRes(response, _baseURL) {
  let {
    config,
    data
  } = response;
  let {
    url
  } = config;
  let {
    code,
    message: msg,
    data: result
  } = data;
  let blacklist = ["/sso/user", "/user/lately/learn/course", "/payment/check/order"];
  let flag = blacklist.some(item => url.indexOf(item) !== -1);
  /**
   * 过滤特殊接口 blacklist
   * 过滤老接口 _baseURL
   * 很多接口在code==0时，做了二级校验，目前不确定有多少，放开code==0错误拦截校验
   * */

  if (url.indexOf(_baseURL) != -1 && !flag) {
    switch (code) {
      case "0":
      case 0:
        // msg && message.error(msg);
        // throw Error(msg);
        break;

      case "1":
      case 1:
        break;

      case "120030002":
      case 120030002:
        let {
          url,
          loginToken,
          orderNo
        } = result;
        Local.setItem("authLoginFaceItem", {
          loginToken,
          orderNo
        }, true);
        window.location.href = url;
        break;

      default:
        msg && message.error(msg);
      // throw Error(msg);
    }
  }
}

export default axios;